export const CONTENT_MAX_WIDTH = 952;
